/**
 * Organize an array into multiple arrays depending on the value on the specified property.
 * For example:
 * [
 *     {ID: 1, status: Active}
 *     {ID: 2, status: Inactive}
 *     {ID: 3, status: Active}
 * ]
 * =
 * {
 *     Active: [
 *         {ID: 1, status: Active}
 *         {ID: 3, status: Active}
 *     ]
 *     Inactive: [
 *         {ID: 2, status: Inactive}
 *     ]
 * }
 *
 * @param {Array} input
 * @param {string} property
 *
 * @return {object}
 */
const organizeByProperty = (input, property) => {
    const result = {};

    input.forEach((item) => {
        const value = item[property];

        if (!result.hasOwnProperty(value)) {
            result[value] = [];
        }

        result[value].push(item);
    });

    return result;
};

module.exports = {
    organizeByProperty,
};
